import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.984 15.002v-.012c0 .002-.025.017-.08.017.027 0 .053-.005.08-.005v.005H5.157c-1.475 0-2.848-.991-3.11-2.442a3 3 0 012.947-3.55c.37 0 .72.075 1.048.198l-.021.764a1.008 1.008 0 002.003.16c.06-.52.15-1.173.285-1.835.41-2.02 3.046-3.651 5.576-3.203 1.893.336 3.446 1.82 3.902 3.689.793 3.253-1.807 6.164-4.803 6.214M17.05 4.36l2.656-2.657A.998.998 0 1018.295.292l-3.102 3.102a6.954 6.954 0 00-2.236-.372 6.974 6.974 0 00-6.425 4.261c-1.227-.4-2.6-.476-4.228.678C.874 8.975-.1 10.578.01 12.328a4.979 4.979 0 002.344 3.905L.293 18.295a.999.999 0 101.412 1.413l2.758-2.758c.176.02.35.054.53.054h7.99c-.01 0-.018-.003-.028-.003.01 0 .029-.003.029-.003 3.995-.059 6.936-3.162 6.936-6.985a6.98 6.98 0 00-2.87-5.652",
  fillRule: "evenodd"
});

var CloudsIcon = function CloudsIcon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
CloudsIcon.defaultProps = {
  size: 1.5
};
export default CloudsIcon;